import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {FormaDesembolso} from '../_models/forma-desembolso';
import {GarantiasIdoneasCobrosPerfilesRiesgos} from '../_models/garantias-idoneas-cobros-perfiles-riesgos';

@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneaCobrosPerfilesRiesgosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasCobrosPerfilesRiesgos/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) { }

  listAll() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos[] ) );
  }

  listHabilitado() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos[] ) );
  }

  searchById( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos ) );
  }

  listadoPorIdGarantiaIdonea( idGarantiaIdonea: string ) {
    return this.httpClient.get(   `${this.rutServicio}garantiaIdonea/${idGarantiaIdonea}` ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos[] ) );
  }

  listadoPorIdGarantiaIdoneaHabilitado( idGarantiaIdonea: string ) {
    return this.httpClient.get(   `${this.rutServicio}garantiaIdonea/${idGarantiaIdonea}/enabled` ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos[] ) );
  }

  listadoPorPerfilHabilitado( idPerfilRiesgo: string ) {
    return this.httpClient.get(   `${this.rutServicio}perfilRiesgo/${idPerfilRiesgo}/enabled` ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos[] ) );
  }

  crear( regCrear: GarantiasIdoneasCobrosPerfilesRiesgos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasCobrosPerfilesRiesgos ) );
  }

  actualizar( regActualizar: GarantiasIdoneasCobrosPerfilesRiesgos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  actualizarBulk( registros: GarantiasIdoneasCobrosPerfilesRiesgos ) {
    registros.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio + 'bulk', registros ).pipe( map( res => res as any ) );
  }

  verificarRango( registro: GarantiasIdoneasCobrosPerfilesRiesgos ) {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio + 'validarRangos', registro ).pipe( map( res => res as any ) );
  }
}
